/* V9.2 header: text, settings and animation are server-rendered/CSS-driven.
   This optional enhancement only pauses animation in hidden tabs and while
   the Header section is selected in Shopify's theme editor. */
(function () {
  'use strict';

  if (window.abV92HeaderReady) return;
  window.abV92HeaderReady = true;

  var selector = '[data-ab-v92-header-message]';

  function syncPauseState() {
    document.querySelectorAll(selector).forEach(function (message) {
      var paused = document.hidden || message.dataset.abV92EditorSelected === 'true';
      message.setAttribute('data-ab-v92-paused', paused ? 'true' : 'false');
    });
  }

  function setEditorSelection(event, selected) {
    if (!event.target || !event.target.querySelectorAll) return;
    event.target.querySelectorAll(selector).forEach(function (message) {
      message.dataset.abV92EditorSelected = selected ? 'true' : 'false';
    });
    syncPauseState();
  }

  document.addEventListener('visibilitychange', syncPauseState);
  document.addEventListener('shopify:section:load', syncPauseState);
  document.addEventListener('shopify:section:select', function (event) {
    setEditorSelection(event, true);
  });
  document.addEventListener('shopify:section:deselect', function (event) {
    setEditorSelection(event, false);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncPauseState, { once: true });
  } else {
    syncPauseState();
  }
}());
